import React, { useState } from 'react'
import PasswordStep from './PasswordStep'
import { isEmail } from 'validator'
import { Button, Stack, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface EmailStepProps {
    onStartEmailAuth: () => void
}

const EmailStep: React.FC<EmailStepProps> = ({ onStartEmailAuth }) => {
    const { t } = useTranslation()
    const [email, setEmail] = useState('')
    const [error, setError] = useState<string | null>(null)
    const [showPasswordStep, setShowPasswordStep] = useState(false)

    const handleNext = () => {
        const trimmedEmail = email.trim()
        if (isEmail(trimmedEmail)) {
            setShowPasswordStep(true)
            onStartEmailAuth()
            return
        }

        setError(t('login.email_step.invalid_email'))
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(e.target.value)

        if (error) setError(null) // Clear error when user starts typing
    }

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleNext()
        }
    }

    if (showPasswordStep) {
        return <PasswordStep email={email.trim()} />
    }

    return (
        <Stack>
            <TextField
                fullWidth
                // eslint-disable-next-line jsx-a11y/no-autofocus -- first field of a fresh step, nothing else to focus instead
                autoFocus
                label={t('login.email_step.email_label')}
                type="email"
                value={email}
                onChange={handleChange}
                onKeyDown={handleKeyPress}
                error={!!error}
                helperText={error}
            />

            <Button variant="contained" color="primary" onClick={handleNext} disabled={!email || !!error} fullWidth>
                {t('login.email_step.next_button')}
            </Button>
        </Stack>
    )
}

export default EmailStep
